export default __webpack_public_path__ + "083fbb4cdc5f9f8ae01ef169769d7a50.png";